import type { TAmendmentDifferenceValue } from "./amendmentHistoryTypes"
import { displayText } from "../../../utils/general/generalUtils"

/**
 * Converts a raw difference value into a display string. Handles
 * primitives, attachment objects, and nullish values.
 *
 * @param value - The raw value from an amendment change entry.
 * @returns A human-readable string representation.
 */
const formatDifferenceValue = (value: TAmendmentDifferenceValue): string => {
    if (value === null || value === undefined) {
        return "-"
    }

    if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
    ) {
        return String(displayText(value))
    }

    if (typeof value === "object") {
        const maybeAttachment = value as {
            fileUrl?: unknown
            fileName?: unknown
        }
        if (typeof maybeAttachment.fileName === "string") {
            return maybeAttachment.fileName
        }
        if (typeof maybeAttachment.fileUrl === "string") {
            return maybeAttachment.fileUrl
        }
    }

    return "-"
}

export { formatDifferenceValue }
